"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var jackpot_service_1 = require("@pbl/pbl-react-core/lib/services/jackpot-service");
var raffle_service_1 = require("@pbl/pbl-react-core/lib/services/raffle-service");
var react_1 = __importStar(require("react"));
var constants_1 = __importDefault(require("../../config/constants"));
var GameSelection_1 = __importDefault(require("./../../modules/NumberCheckerWidget/components/GameSelection"));
var NumbersCheck_1 = __importDefault(require("./../../modules/NumberCheckerWidget/components/NumbersCheck"));
var RaffleNumbersCheck_1 = __importDefault(require("./../../modules/NumberCheckerWidget/components/RaffleNumbersCheck"));
var AccessibleNumbersCheck_1 = __importDefault(require("./components/v3/AccessibleNumbersCheck"));
var NumberCheckerScreen = function (_a) {
    var identifier = _a.identifier, gameConfigs = _a.gameConfigs;
    var theme = (0, core_1.useTheme)();
    var ref = (0, react_1.useRef)(null);
    var _b = (0, react_1.useState)([]), lottoGames = _b[0], setLottoGames = _b[1];
    var _c = (0, react_1.useState)(null), selectedGame = _c[0], setSelectedGame = _c[1];
    var _d = (0, react_1.useState)([]), raffleGames = _d[0], setRaffleGames = _d[1];
    var _e = (0, react_1.useState)(''), error = _e[0], setError = _e[1];
    var _f = (0, react_1.useState)(false), loading = _f[0], setLoading = _f[1];
    (0, react_1.useEffect)(function () {
        getLottoData();
        getRaffleData();
    }, []);
    (0, react_1.useEffect)(function () {
        getGameData();
    }, [identifier, lottoGames, raffleGames]);
    var getGameData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var selectedLottoGame, selectedRaffleGame;
        return __generator(this, function (_a) {
            if (identifier) {
                selectedLottoGame = lottoGames.find(function (l) { return l.id === identifier; });
                selectedRaffleGame = raffleGames.find(function (r) { return Number(r.id) === identifier; });
                if (selectedLottoGame || selectedRaffleGame) {
                    setLoading(true);
                }
                if (selectedLottoGame) {
                    selectedLottoGame.type = 'draw';
                    setSelectedGame(selectedLottoGame);
                    setError('');
                }
                else if (selectedRaffleGame) {
                    selectedRaffleGame.type = 'raffle';
                    setSelectedGame(selectedRaffleGame);
                    setError('');
                }
                else if (loading) {
                    setError('Game Id is not available');
                }
            }
            return [2];
        });
    }); };
    var getLottoData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, jackpot_service_1.JackpotService.getJackpotGames()];
                case 1:
                    response = (_a.sent());
                    if (typeof response === 'string') {
                        return [2];
                    }
                    setLottoGames(response.map(function (game) { return (__assign(__assign({}, game), { type: 'draw', gameBoardConfig: gameConfigs.find(function (value) { return value.gameId === game.id; }) })); }));
                    return [2];
            }
        });
    }); };
    var clickGame = function (game) {
        if (identifier) {
            return;
        }
        setSelectedGame(game);
        setTimeout(function () {
            var _a;
            (_a = ref.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ behavior: 'smooth' });
        }, 10);
    };
    var getRaffleData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, raffle_service_1.RaffleService.getRaffleGames()];
                case 1:
                    response = _a.sent();
                    if (typeof response === 'string') {
                        return [2];
                    }
                    setRaffleGames(response.map(function (_a) {
                        var gameId = _a.gameId, name = _a.name, ticketFullImage = _a.ticketFullImage, playBegin = _a.playBegin;
                        return ({
                            id: gameId,
                            name: name,
                            image: ticketFullImage,
                            startDate: playBegin,
                            type: 'raffle'
                        });
                    }));
                    return [2];
            }
        });
    }); };
    if (error.length > 0) {
        return (react_1.default.createElement(core_1.Typography, { color: "primary", variant: "h2" }, error));
    }
    else {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { style: {
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'flex-start',
                    alignItems: 'center'
                } },
                !identifier && (react_1.default.createElement(GameSelection_1.default, { selectGame: clickGame, selectedGame: selectedGame, games: __spreadArray(__spreadArray([], lottoGames, true), raffleGames, true), theme: theme })),
                selectedGame && (react_1.default.createElement(react_1.default.Fragment, null,
                    selectedGame.type === 'draw' &&
                        (constants_1.default.ACCESSIBLE_NUMBER_CHECKER_WIDGET ? (react_1.default.createElement(AccessibleNumbersCheck_1.default, { selectedGame: selectedGame, theme: theme, key: selectedGame.id, scrollToRef: ref })) : (react_1.default.createElement(NumbersCheck_1.default, { selectedGame: selectedGame, theme: theme, key: selectedGame.id, scrollToRef: ref }))),
                    selectedGame.type === 'raffle' && (react_1.default.createElement(RaffleNumbersCheck_1.default, { selectedGame: selectedGame, theme: theme, key: selectedGame.id, scrollToRef: ref })))))));
    }
};
exports.default = NumberCheckerScreen;
//# sourceMappingURL=index.js.map